const REFUSAL_STATUSES = [409, 422];

/**
 * The reason a refused request carries for the customer: the `detail` of the first
 * JSON:API error the API sends when it turns a request down (a contract with no
 * services, a clause left unaccepted, a closed season). Any other failure is internal,
 * and its text was never written for the customer; per-field validation errors belong
 * to the form instead.
 */
export const apiRefusalDetail = (error: unknown): string | null => {
  const response = (error as { response?: { status?: number; data?: { errors?: unknown } } })
    ?.response;

  if (!response?.status || !REFUSAL_STATUSES.includes(response.status)) return null;

  const errors = response.data?.errors;
  if (!Array.isArray(errors)) return null;

  const detail = (errors[0] as { detail?: unknown } | undefined)?.detail;

  return typeof detail === "string" && detail !== "" ? detail : null;
};
